import { render, staticRenderFns } from "./ui-info-box.vue?vue&type=template&id=3e5a4e17&scoped=true&"
import script from "./ui-info-box.vue?vue&type=script&lang=js&"
export * from "./ui-info-box.vue?vue&type=script&lang=js&"
import style0 from "./ui-info-box.vue?vue&type=style&index=0&id=3e5a4e17&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5a4e17",
  null
  
)

export default component.exports